export const createOverlay = (element, className, text) => {
  const overlay = document.createElement("div")
  overlay.className = className
  overlay.textContent = text
  element.appendChild(overlay)
  return overlay
}

export const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

export const slugify = (value) =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "plan"

export const fitRectWithinRect = (sourceWidth, sourceHeight, maxWidth, maxHeight) => {
  const safeSourceWidth = Math.max(sourceWidth || 1, 1)
  const safeSourceHeight = Math.max(sourceHeight || 1, 1)
  const safeMaxWidth = Math.max(maxWidth || 1, 1)
  const safeMaxHeight = Math.max(maxHeight || 1, 1)
  const sourceAspect = safeSourceWidth / safeSourceHeight
  const targetAspect = safeMaxWidth / safeMaxHeight

  if (sourceAspect > targetAspect) {
    return {
      width: safeMaxWidth,
      height: safeMaxWidth / sourceAspect
    }
  }

  return {
    width: safeMaxHeight * sourceAspect,
    height: safeMaxHeight
  }
}

export const clampNumber = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum)

export const parseFloatOr = (value, fallback) => {
  const parsed = Number.parseFloat(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const parseIntegerOr = (value, fallback) => {
  const parsed = Number.parseInt(value, 10)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const parseJsonOr = (value, fallback) => {
  if (!value) return fallback

  try {
    return JSON.parse(value)
  } catch (_error) {
    return fallback
  }
}

export const parseBooleanOr = (value, fallback) => {
  if (value === true || value === "true") return true
  if (value === false || value === "false") return false
  return fallback
}

export const parseNullableFloat = (value) => {
  if (value === null || value === undefined || value === "") return null
  const parsed = Number.parseFloat(value)
  return Number.isFinite(parsed) ? parsed : null
}

export const normalizeViewMode = (mode) => {
  const normalized = String(mode || "").trim().toLowerCase()
  if (normalized === "2d-ortho") return "2d"
  return normalized
}

export const isPerspective2DMode = (_mode) => false
export const isOrthographic2DMode = (mode) => normalizeViewMode(mode) === "2d"
export const is2DLikeMode = (mode) => isPerspective2DMode(mode) || isOrthographic2DMode(mode)

export const formatCoordinate = (value) => Number(value || 0).toFixed(2)

export const formatPosition = (position) => {
  if (!position) return "-"
  return `${formatCoordinate(position.x)}, ${formatCoordinate(position.y)}, ${formatCoordinate(position.z)}`
}

export const normalizeThingKind = (value) =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")

export const normalizePlacementVerticalMode = (value) => {
  const normalized = value?.toString().trim().toLowerCase()
  return normalized === "ceiling" ? "ceiling" : "surface"
}

export const escapeHtml = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
